import * as React from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';

import logo01white from "../../assets/images/logos/Logo-01-white.png";
import AuthService from "../../services/authService";

interface Iprops {
    history: any
}

interface IState {

}

class HeaderComponent extends React.Component<Iprops, IState> {
    authService = new AuthService();

    constructor(props) {
        super(props);
    }

    logout = () => {
        this.authService.logout();
        this.props.history.push('/login');
    }

    public render() {
        return (
            <header className="app-header" style={{ display: "flex" }}>
                <div style={{ width: "100%" }}>
                    <Link to="/"><img src={logo01white} className="app-logo" alt="logo" /></Link>
                    <h1 className="app-title">Admin Prototype</h1>
                    <div className="app-version">ver. {process.env.REACT_APP_VERSION} ({process.env.NODE_ENV})</div>
                </div>
                <div style={{ width: "250px", textAlign: "right" }}>
                    <img src="/images/EU-ProjectInfo.png" />
                    {this.authService.isAuthenticated()
                        ? <div style={{ display: 'flex', flexDirection: 'row' }}>{this.authService.getLoginName()} <Link to="#" onClick={this.logout} style={{ marginLeft: 5 }}>Logout</Link> </div>
                        : null
                    }
                </div>
            </header>
        )
    }
}

const mapsStateToProps = state => {
    return {
        lang: state.common.lang
    };
}

export default withRouter(connect()(HeaderComponent));